import { IPublishInfoState, EPublishOfferStatus } from '../../types/reducers/publishInfo';

export const defaultState: IPublishInfoState = {
  status: EPublishOfferStatus.Initial,
  errorCode: null,
  errorMessage: null,
  errors: null,
  type: null,
  message: null,
  servicesToDeactivate: null,
  checkFailed: false,
  isSubagentNotEnoughMoney: false,
};
